module.exports = __webpack_public_path__ + "img/logo-artrade2.a721a5a9.png";